// removed by extract-text-webpack-plugin
module.exports = {"Portrait":"_3dWaCl0P","AboutMeCard":"_2ij69Pz4","TestimonialContainer":"_3M5dLXgG","HiddenMobile":"_1On08KRG"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/home-page.styles.scss
// module id = 258
// module chunks = 0